import { mergeStyles } from "@fluentui/react";

export const appBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: '16dvw'
}]);

export const xxlAppBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(18dvw, 20dvw, 22dvw)'
}]);

export const xlAppBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(12dvw, 16dvw, 18dvw)'
}]);

export const lgAppBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(30dvw, 32dvw, 34dvw)'
}]);

export const mdAppBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(28dvw, 30dvw, 32dvw)'
}]);

export const smAppBannerStyles = mergeStyles([{
    width: 'auto',
    height: 'auto',
    maxWidth: 'clamp(54dvw, 55dvw, 56dvw)'
}]);

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '2rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.4rem, 2.5vw, 1.5rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const descriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '2rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const xxlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.4rem, 2.5vw, 1.5rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const xlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.3rem, 2.5vw, 1.4rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const lgDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.2rem, 2.5vw, 1.3rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const mdDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const smDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    fontWeight: 500,
    color: '#323130',

    textAlign: 'center'
}]);